

import {USAGE_NO_DATA, USAGE_NO_LOGIN, USAGE_DATA} from "~/constants/empty";

export default {
    name: "Empty",
    props: {
        usage: {
            type: String,
            default: USAGE_DATA,
        }
    },
    data() {
        return {
            newUsage: this.usage,
        }
    },
    watch: {
        usage(newVal) {
            this.newUsage = newVal
        }
    },
    computed: {
        isNoLogin() {
            return this.newUsage === USAGE_NO_LOGIN
        },
        isNoData() {
            return this.newUsage === USAGE_NO_DATA
        }
    },
    methods: {
        onLogin() {
            this.$emit('toLogin')
        },
        onHome() {
            this.$emit('toHome')
        }
    }
}
